import * as React from "react";
import type { SVGProps } from "react";
const CarWash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clip0_4355_2877)">
      <path d="m9.8892 11.6635 5.264-.0012c.253.0021.4812.1583.5653.3998l.715 2.0019-7.8229-.0003.714-2.0005c.0834-.2397.3126-.3982.5646-.3997m-2.8231-.4082-1.0624 2.9751a2.097 2.097 0 0 0-1.2792 1.9345l-.002 1.4991-.0015 2.3996-.0008 1.1998c-.0006.6641.5387 1.199 1.1991 1.2006l.6012-.0019c.664.0006 1.199-.5387 1.2006-1.1991l.0007-1.1998 9.6013.0013-.0008 1.1998c-.0006.664.5387 1.1989 1.1991 1.2006l.6013-.002c.664.0007 1.1989-.5386 1.2005-1.1991l.0008-1.1998-.0032-2.4023.0021-1.4991c-.0001-.8696-.5292-1.613-1.2797-1.936l-1.0616-2.9767c-.4248-1.1945-1.558-1.9895-2.8242-1.9919l-5.2704.0068c-1.2698-.0014-2.3989.7981-2.8245 1.9914zm.6557 4.9101a.9.9 0 0 1 .6369.2633.9.9 0 0 1 .2642.6366.9005.9005 0 1 1-.9011-.8999m8.7003.8988a.901.901 0 0 1 .5431-.8749.9.9 0 0 1 1.2543.8747.9.9 0 0 1-.2633.6369.9003.9003 0 0 1-1.2735.0008.9.9 0 0 1-.2642-.6365zM8.5 3.7836c.0058-1.2694-1.2098-2.3929-1.6181-2.7347a.205.205 0 0 0-.266 0C6.2052 1.3884 4.9942 2.4921 5 3.7824c0 1.0442.7852 1.8935 1.75 1.8935S8.5 4.8265 8.5 3.7835m5.25 0c.0058-1.2694-1.2098-2.394-1.6182-2.7347a.205.205 0 0 0-.266 0c-.4118.3395-1.6228 1.4443-1.617 2.7347.0012 1.043.7864 1.8923 1.7512 1.8923s1.75-.8494 1.75-1.8924m5.25 0c.0058-1.2694-1.2099-2.394-1.6182-2.7347a.205.205 0 0 0-.266 0c-.4106.3395-1.6216 1.4432-1.6158 2.7335 0 1.0442.7852 1.8935 1.75 1.8935S19 4.8265 19 3.7835" />
    </g>
    <defs>
      <clipPath id="clip0_4355_2877">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default CarWash;
